import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelopeNewIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 24 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.703 5.3a2.303 2.303 0 0 0-2.299 2.4H2.4v9.6c0 1.324 1.077 2.4 2.4 2.4h14.4c1.324 0 2.4-1.076 2.4-2.4V7.7h-.003c0-.034.003-.064.003-.098A2.303 2.303 0 0 0 19.298 5.3H4.703ZM19.8 10.11v7.19c0 .33-.27.6-.6.6H4.8c-.33 0-.6-.27-.6-.6v-7.19l5.805 4.403a3.297 3.297 0 0 0 3.99 0L19.8 10.11ZM4.2 7.602c0-.277.225-.502.503-.502h14.595a.503.503 0 0 1 .304.904l-6.694 5.077a1.508 1.508 0 0 1-1.815 0L4.399 8.004a.506.506 0 0 1-.199-.402Z" })
});
export default SvgEnvelopeNewIcon;
